module.exports = __webpack_public_path__ + "img/VCB.a43a3209.png";